import { rem } from '@mantine/core';

interface IconProps extends React.ComponentPropsWithoutRef<'svg'> {
  size?: number | string;
}

export function OverhangIcon({ size, style, ...others }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 36 36'
      fill='currentColor'
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <circle cx='21.63' cy='21.63' r='3' />
      <path d='M31.06,5.82a3,3,0,0,0-2.12-.88h-21a3,3,0,0,0-3,3v21a3,3,0,0,0,.88,2.12Z' />
    </svg>
  );
}

export function RoofIcon({ size, style, ...others }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 36 36'
      fill='currentColor'
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <circle cx='18' cy='23.2' r='3' />
      <path d='M31.5,18.61V8.11a3,3,0,0,0-3-3H7.5a3,3,0,0,0-3,3v10.5Z' />
    </svg>
  );
}

export function SlabIcon({ size, style, ...others }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 36 36'
      fill='currentColor'
      transform='scale(-1,1)'
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <circle cx='14.37' cy='14.37' r='3' />
      <path d='M4.94,30.18a3,3,0,0,0,2.12.88h21a3,3,0,0,0,3-3v-21a3,3,0,0,0-.88-2.12Z' />
    </svg>
  );
}

export function VerticalIcon({ size, style, ...others }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 36 36'
      fill='currentColor'
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <circle cx='23.03' cy='18' r='3' />
      <path d='M18.44,4.5H7.94a3,3,0,0,0-3,3v21a3,3,0,0,0,3,3h10.5Z' />
    </svg>
  );
}
